import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import PolicyDetailsFilters from './PolicyDetailsFilter';
import { Checkbox, Popover, Spin } from 'antd';
import {
  ColumnVisiblity,
  CUSTOMER_TYPE,
  CUSTOMER_TYPE_ENTITY,
  CUSTOMER_TYPE_FLAG,
  EMPTY_ARRAY,
  EMPTY_OBJECT,
  INSIGHT_TYPE,
  NUMBER_ZERO,
  PAGINATION,
  POLICY_DETAILS_COLUMNS,
  PolicyDetailFieldMapping,
  PolicyDetailsField,
  SORT_BY,
  TABLE_NAME_POLICY_DETAILS,
  PARENT_PAYER_VIEW_POLICY_STATUS_COLUMN_INFO,
  PAYER_VIEW_POLICY_STATUS_COLUMN_INFO,
  PAYER_VIEW_RELATIVE_ACCESS_POSITION_COLUMN_INFO,
  PARENT_PAYER_VIEW_RELATIVE_ACCESS_POSITION_COLUMN_INFO,
  POLICY_STATUS_COL_POPOVER_LINK,
  PAYER_MDM_ID_COLUMN_NAME,
  POLICY_DETAILS_PLAN_COLUMN_NAME,
  RELATIVE_ACCESS_POSITION_COLUMN_NAME,
  RELATIVE_ACCESS_POSITION_COLUMN_POPOVER_LINK,
} from 'constants/constants';
import {
  setPolicyDetailsProduct,
  setPolicyDetailsIndication,
  setPolicyDetailsCompetitorProduct,
  setPolicyDetailsEcosystemName,
  setPolicyDetailsPolicyState,
  setPolicyDetailsBookOfBusiness,
  setPolicyDetailsBenefitType,
  setPolicyDetailsIniState,
  setPolicyDetailsPlan,
  setPolicyDetailsPayer,
  setSelectedCustomer,
  setInsightType,
  setSelectedInsightView,
  setAllInsightView,
  setFilterInit,
  setSeletedView,
} from 'store/customer/customerViewSlice';
import classes from './PolicyDetails.module.scss';
import { useEffect, useMemo, useState } from 'react';
import {
  exportTableData,
  getPayerTimeSpanDates,
  getPolicyTableData,
} from 'store/customer/customer-view-actions';
import { useDispatch, useSelector } from 'react-redux';
import { getRestrictedColumnWithRecursion, removeSpace } from 'utils/utils';
import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import { startCase } from 'lodash';
import OverlayIcon from 'components/shared/overlay-icon/OverlayIcon';
import { useNavigate } from 'react-router-dom';
import PopoverAsTooltip from 'components/customer/popover/PopoverAsTooltip';

const PolicyDetails = ({ data }) => {
  const selectedPayer = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters?.Payer.selectedValue
  );
  const selectedPlan = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters?.Plan.selectedValue
  );
  const selectedProduct = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters.Product.selectedValue
  );
  const selectedIndication = useSelector(
    (state) =>
      state.CustomerView?.policyDetailsFilters?.Indication.selectedValue
  );
  const selectedCompetitorProduct = useSelector(
    (state) =>
      state.CustomerView?.policyDetailsFilters?.CompetitorProduct.selectedValue
  );
  const selectedEcosystemName = useSelector(
    (state) =>
      state.CustomerView?.policyDetailsFilters?.EcosystemName.selectedValue
  );
  const selectedPolicyState = useSelector(
    (state) =>
      state.CustomerView?.policyDetailsFilters?.PolicyState.selectedValue
  );
  const selectedBookOfBusiness = useSelector(
    (state) =>
      state.CustomerView?.policyDetailsFilters?.BookOfBusiness.selectedValue
  );
  const selectedBenefitType = useSelector(
    (state) =>
      state.CustomerView?.policyDetailsFilters?.BenefitType.selectedValue
  );

  const [timeFrame, setTimeFrame] = useState();
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const size = { x: 1100, y: 400 };

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );

  const defaultPageSize = PAGINATION.defaultPageSize;
  const initailState = {
    values: [],
    offset: 0,
    totalSize: 0,
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [policiDetailsData, setPolicyDetailsData] = useState(initailState);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setSortBy] = useState(
    CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)?.includes(
      selectedCustomer.flag
    )
      ? { column: 'mcoEntity', order: SORT_BY.ascend }
      : {
          column: 'entityContributionToGeography',
          order: SORT_BY.descend,
        }
  );

  const pagination = {
    current: pageIndex,
    total: policiDetailsData?.totalSize,
    pageSize: pageSize,
    pageSizeOptions: PAGINATION.pageSizeOptions,
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };

  const { roleId } = useSelector((state) => state?.Auth?.userClaimObject);

  const columnRestriction = useSelector(
    (state) => state?.CustomerView?.columnsRestiction
  );
  const selectedView = useSelector(
    (state) => state?.CustomerView?.selectedView
  );

  const isExporting = useSelector(
    (state) => state?.CustomerView?.exportPolicyDetails
  );

  // Remove restricted columns as per role and show in table
  const policDeatilsColumns = useMemo(() => {
    let columns = getRestrictedColumnWithRecursion(
      TABLE_NAME_POLICY_DETAILS,
      POLICY_DETAILS_COLUMNS,
      columnRestriction
    );

    // Remove columns which are not available for payer view
    if (
      CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)?.includes(
        selectedCustomer.flag
      )
    ) {
      columns = columns?.filter(
        (item) =>
          item.dataIndex !== 'statusConsistencyAcrossPlans' &&
          item.dataIndex !== 'policyUpdateURL' &&
          item.dataIndex !== 'entityContributionToGeography' &&
          item.dataIndex !== 'entitySales'
      );
    }

    // Remove columns which are not available for parent payer view
    if (
      CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PARENTPAYER)?.includes(
        selectedCustomer.flag
      )
    ) {
      columns = columns?.filter((item) => item.dataIndex !== 'policyLink');
    }
    return columns;
  }, [selectedCustomer?.value]);

  // Get Default selected columns as per configuration and show in column setting popover
  const getDefaultSelectedColumns = () => {
    // convert nested array to flat array of string
    return policDeatilsColumns.reduce((result, column) => {
      if (
        column.isMandatory === 'Y' &&
        column.columnVisiblity !== ColumnVisiblity.Optional &&
        column.key
      ) {
        result.push(column.key);
        if (column.key === 'ecosystem' || column.key === 'policy') {
          column.children.map((subcolumn) => {
            if (
              subcolumn.isMandatory === 'Y' &&
              subcolumn.columnVisiblity !== ColumnVisiblity.Optional &&
              subcolumn.key
            ) {
              // Remove columns which are not available for payer view
              if (
                CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)?.includes(
                  selectedCustomer.flag
                )
              ) {
                if (
                  subcolumn.dataIndex !== 'statusConsistencyAcrossPlans' &&
                  subcolumn.dataIndex !== 'policyUpdateURL' &&
                  subcolumn.dataIndex !== 'entityContributionToGeography' &&
                  subcolumn.dataIndex !== 'entitySales'
                ) {
                  result.push(subcolumn.key);
                }
              }
              // Remove columns which are not available for parent payer view
              if (
                CUSTOMER_TYPE_FLAG.get(
                  CUSTOMER_TYPE_ENTITY.PARENTPAYER
                )?.includes(selectedCustomer.flag)
              ) {
                if (subcolumn.dataIndex !== 'policyLink') {
                  result.push(subcolumn.key);
                }
              }
            }
          });
        }
      }

      return result;
    }, []);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    getDefaultSelectedColumns()
  );

  useEffect(() => {
    setSelectedColumns(getDefaultSelectedColumns());
  }, [selectedCustomer?.value]);

  // Filter selected columns to show in table as per selected columns from setting popover
  function filterColumns(columns, selectedKeys) {
    const customerFiltered = CUSTOMER_TYPE_FLAG.get(
      CUSTOMER_TYPE_ENTITY.PARENTPAYER
    )?.includes(selectedCustomer.flag)
      ? columns.filter((item) => item.dataIndex !== 'policyLink')
      : columns.filter(
          (item) =>
            item.dataIndex !== 'statusConsistencyAcrossPlans' &&
            item.dataIndex !== 'policyUpdateURL' &&
            item.dataIndex !== 'entityContributionToGeography' &&
            item.dataIndex !== 'entitySales'
        );

    return customerFiltered
      .map((column) => {
        if (column.children && Array.isArray(column.children)) {
          const filteredChildren = filterColumns(column.children, selectedKeys);
          if (filteredChildren.length > 0) {
            return { ...column, children: filteredChildren };
          }
          return null; // No matching children, remove this parent
        } else {
          return selectedKeys.includes(column.key) ? column : null;
        }
      })
      .filter(Boolean); // Remove nulls
  }

  const filteredColumns = filterColumns(policDeatilsColumns, selectedColumns);

  const handleFilterChange = (value, field) => {
    if (field === PolicyDetailsField.Payer) {
      dispatch(setPolicyDetailsPayer({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.Plan) {
      dispatch(setPolicyDetailsPlan({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.Product) {
      if (!value) {
        dispatch(setPolicyDetailsIndication({ selectedValue: null }));
        dispatch(
          setPolicyDetailsCompetitorProduct({
            selectedValue: null,
          })
        );
      }
      dispatch(setPolicyDetailsProduct({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.Indication) {
      if (!value) {
        dispatch(
          setPolicyDetailsCompetitorProduct({
            selectedValue: null,
          })
        );
      }
      dispatch(setPolicyDetailsIndication({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.CompetitorProduct) {
      dispatch(setPolicyDetailsCompetitorProduct({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.BenefitType) {
      dispatch(setPolicyDetailsBenefitType({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.BookOfBusiness) {
      dispatch(setPolicyDetailsBookOfBusiness({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.EcosystemName) {
      dispatch(setPolicyDetailsEcosystemName({ selectedValue: value }));
    }
    if (field === PolicyDetailsField.PolicyState) {
      dispatch(setPolicyDetailsPolicyState({ selectedValue: value }));
    }
  };

  const handlePopoverVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  useEffect(() => {
    (async () => {
      const response = await getPayerTimeSpanDates({ roleId });
      setTimeFrame(response);
    })();
  }, []);

  useEffect(() => {
    if (!selectedCustomer?.label) {
      setPolicyDetailsData(initailState);
      return;
    }

    if (selectedColumns?.length !== 0) {
      getPolicyData(sortBy.column, sortBy.order);
      setPageIndex(1);
      setPageSize(defaultPageSize);
    }
  }, [
    selectedPayer,
    selectedPlan,
    selectedProduct,
    selectedIndication,
    selectedCompetitorProduct,
    selectedEcosystemName,
    selectedBookOfBusiness,
    selectedBenefitType,
    selectedPolicyState,
    selectedColumns?.length,
    selectedCustomer?.value,
  ]);

  const resetFilters = () => {
    dispatch(setPolicyDetailsIniState());
  };

  const policyDetailsTooltip = (
    <Tooltip className='gne-tooltip'>
      <span>
        Estimated Payer Sales Data (Plantrak and Imputed Sales) is latest as of{' '}
        {timeFrame?.salesDataAsOf} (R12M)
        <br />
        Lives Data (DRG) is latest as of {timeFrame?.livesDataAsOf} <br />
        Policy Data (MMIT) is latest as of {timeFrame?.policyDataAsOf}
      </span>
    </Tooltip>
  );

  const downloadData = async () => {
    let payload = {
      mdmId: selectedCustomer?.value,
      entityType: selectedCustomer?.flag,
      sortByColumn: selectedColumns?.includes(
        PolicyDetailFieldMapping[sortBy.column]
      )
        ? PolicyDetailFieldMapping[sortBy.column]
        : undefined,
      sortByDirection: selectedColumns?.includes(
        PolicyDetailFieldMapping[sortBy.column]
      )
        ? sortBy.order
        : undefined,
      dimension: [],
      offset: 0,
      pageSize: pageSize,
      requestType: CUSTOMER_TYPE_FLAG.get(
        CUSTOMER_TYPE_ENTITY.PARENTPAYER
      ).includes(selectedCustomer?.flag)
        ? 'ParentPayerPolicyDetail'
        : 'PayerPolicyDetail',
      selectedColumns: getSortedSelectedColumn(POLICY_DETAILS_COLUMNS),
      planId: selectedPlan?.map((item) => item?.value),
      payerId: selectedPayer?.map((item) => item.value),
      product: selectedProduct?.value,
      indication: selectedIndication?.value,
      competitorProduct: selectedCompetitorProduct?.value,
      ecosystemName: selectedEcosystemName?.map((item) => item.value),
      policyState: selectedPolicyState?.value ?? undefined,
      bookOfBusiness: selectedBookOfBusiness?.map((item) => item.value),
      benefitType: selectedBenefitType?.map((item) => item.value),
      roleId: roleId,
    };

    const fileName = `${removeSpace(startCase(CUSTOMER_TYPE.get(selectedCustomer?.flag)))}-[${selectedCustomer?.label}-${selectedCustomer?.value} ]-PolicyDetails`;
    dispatch(exportTableData('PolicyDetailsTable', fileName, payload));
  };

  const exportTooltip = (
    <Tooltip className='gne-tooltip'>Send to Excel</Tooltip>
  );

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    const nextSelected = checked
      ? [...selectedColumns, value]
      : selectedColumns.filter((item) => item !== value);
    setSelectedColumns(nextSelected);
  };

  const handleSorting = (column, order, pagination) => {
    // Calculate offset
    let offset = Math.ceil(
      pagination?.current * pagination?.pageSize - pagination?.pageSize
    );

    // Reset Offset if page size is changed
    let currentPageSize = pagination.pageSize;
    if (pageSize !== currentPageSize) {
      offset = 0;
      setPageSize(currentPageSize);
    }

    setPageIndex(pagination.current);
    setSortBy({ column, order: SORT_BY[order] });

    // Call table Api
    getPolicyData(
      column ? column : sortBy.column,
      SORT_BY[order] ? SORT_BY[order] : undefined,
      offset,
      currentPageSize
    );
  };

  // get flat and sorted array of selected column keys
  const getSortedSelectedColumn = (columns) => {
    return columns.reduce((keys, col) => {
      // Always extract key if it exists, is not 'ecosystem' or 'policy', and is in selectedColumns
      if (
        col.key &&
        col.key !== 'ecosystem' &&
        col.key !== 'policy' &&
        selectedColumns.includes(col.key)
      ) {
        keys.push(col.key);
      }

      // Recursively extract keys from children
      if (col.children && Array.isArray(col.children)) {
        keys.push(...getSortedSelectedColumn(col.children));
      }

      return keys;
    }, []);
  };

  const getPolicyData = async (
    sortByColumn,
    sortByDirection,
    offset = 0,
    pageSize = defaultPageSize
  ) => {
    try {
      setIsLoading(true);
      const payload = {
        mdmId: selectedCustomer?.value,
        entityType: selectedCustomer?.flag,
        sortByColumn: selectedColumns?.includes(
          PolicyDetailFieldMapping[sortByColumn]
        )
          ? PolicyDetailFieldMapping[sortByColumn]
          : undefined,
        sortByDirection: selectedColumns?.includes(
          PolicyDetailFieldMapping[sortByColumn]
        )
          ? sortByDirection
          : undefined,
        dimension: [],
        offset,
        pageSize,
        requestType: CUSTOMER_TYPE_FLAG.get(
          CUSTOMER_TYPE_ENTITY.PARENTPAYER
        ).includes(selectedCustomer?.flag)
          ? 'ParentPayerPolicyDetail'
          : 'PayerPolicyDetail',
        selectedColumns: getSortedSelectedColumn(POLICY_DETAILS_COLUMNS),
        planId: selectedPlan?.map((item) => item?.value),
        payerId: selectedPayer?.map((item) => item?.value),
        product: selectedProduct?.value,
        indication: selectedIndication?.value,
        competitorProduct: selectedCompetitorProduct?.value,
        ecosystemName: selectedEcosystemName?.map((item) => item?.value),
        policyState: selectedPolicyState?.value ?? undefined,
        bookOfBusiness: selectedBookOfBusiness?.map((item) => item?.value),
        benefitType: selectedBenefitType?.map((item) => item?.value),
        roleId: roleId,
      };

      const result = await getPolicyTableData({ ...payload });
      setIsLoading(false);
      if (result?.values?.length > 0) {
        setPolicyDetailsData({ ...result });
      } else {
        setPolicyDetailsData(initailState);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const getPopercolumns = (InputColumn, isAllColumns) => {
    let verify = [];
    InputColumn.map((col) => {
      if (isAllColumns) {
        //for the array of object
        if (col.key === 'ecosystem' || col.key === 'policy') {
          if (
            CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)?.includes(
              selectedCustomer.flag
            ) &&
            col.key === 'policy'
          ) {
            col.children.forEach((subcol) => {
              if (
                subcol.dataIndex !== 'statusConsistencyAcrossPlans' &&
                subcol.dataIndex !== 'policyUpdateURL' &&
                subcol.dataIndex !== 'entityContributionToGeography' &&
                subcol.dataIndex !== 'entitySales' &&
                subcol.dataIndex !== 'statusOverwrite'
              ) {
                verify.push(subcol);
              }
            });
          } else if (
            CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PARENTPAYER)?.includes(
              selectedCustomer.flag
            )
          ) {
            col.children.forEach((subcol) => {
              if (subcol.dataIndex !== 'policyLink') {
                verify.push(subcol);
              }
            });
          }
        } else {
          verify.push(col);
        }
      } else {
        //for the array of string
        if (col !== 'ecosystem' && col !== 'policy') {
          if (
            CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)?.includes(
              selectedCustomer.flag
            ) &&
            col !== 'statusConsistencyAcrossPlans' &&
            col !== 'policyUpdateURL' &&
            col !== 'entityContributionToGeography' &&
            col !== 'entitySales'
          ) {
            return verify.push(col);
          } else if (
            CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PARENTPAYER)?.includes(
              selectedCustomer.flag
            ) &&
            col !== 'policyLink'
          ) {
            return verify.push(col);
          }
        }
      }
    });
    return verify;
  };

  const handlePayerLinkClick = (rowData) => {
    const { mcoEntity } = rowData || EMPTY_OBJECT;
    const payload = {
      value: mcoEntity?.mdmId,
      label: mcoEntity?.entityName,
      flag: CUSTOMER_TYPE_FLAG.get(CUSTOMER_TYPE_ENTITY.PAYER)?.[NUMBER_ZERO],
    };
    dispatch(setFilterInit());
    dispatch(setSeletedView(CUSTOMER_TYPE_ENTITY.PAYER));
    dispatch(setSelectedCustomer(payload));
    dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
    dispatch(setSelectedInsightView(EMPTY_OBJECT));
    dispatch(setAllInsightView(EMPTY_ARRAY));
    navigate(`/customerView/list/${encodeURIComponent(mcoEntity?.entityName)}`);
  };

  const renderPopOver = (title, info, link) => {
    return (
      <>
        <span>{title}</span>
        <PopoverAsTooltip>
          <span>
            {info}
            <a
              href={link}
              target='_blank'
              rel='noreferrer'
              onClick={(e) => {
                e.stopPropagation();
              }}>
              &nbsp; <span className='document_link'>link</span>
            </a>
            .
          </span>
        </PopoverAsTooltip>
      </>
    );
  };

  return (
    <div className='full-width-in-container light-grey pb-3 mt-5'>
      <div
        id='PolicyDetails'
        className='pt-3'>
        <Row>
          <Col
            className='d-flex align-items-center'
            md={6}>
            <p className='title title__bold title__large mb-1'>
              Policy Details
              <OverlayTrigger
                placement='bottom'
                overlay={policyDetailsTooltip}>
                <i className='icon icon__info__gray ms-2'></i>
              </OverlayTrigger>
            </p>
          </Col>
          <Col
            className='d-flex justify-content-end align-items-center pe-0'
            md={6}>
            <Popover
              content={
                <div className={classes.acc_custom_popup}>
                  <ColumnSelectionPanel
                    classes={classes}
                    selectedColumns={getPopercolumns(selectedColumns)}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedView={selectedView}
                    columns={getPopercolumns(policDeatilsColumns, true)}
                  />
                </div>
              }
              trigger='click'
              open={popoverVisible}
              onOpenChange={handlePopoverVisibleChange}>
              <i
                className={`icon icon__affiliations_standardTable_settings ms-3 me-3`}
              />
            </Popover>
            <OverlayIcon
              tooltip={'Reset Filters'}
              onClick={resetFilters}
              className={`icon icon__reset-filters pointer align-center me-3`}
            />
            <OverlayTrigger overlay={exportTooltip}>
              <i
                onClick={downloadData}
                className={`icon icon__affiliations_export_excel1 align-center`}
              />
            </OverlayTrigger>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className='title title__x-small pt-0 title__grey d-flex '>
              <p
                className={`title title__x-small title__italic title__grey ${classes['acc-verbiag']}`}>
                {CUSTOMER_TYPE_FLAG.get(
                  CUSTOMER_TYPE_ENTITY.PARENTPAYER
                ).includes(selectedCustomer?.flag)
                  ? `This view lists Payers owned by the selected Payer Parent. It
                gives you the ability to see all relevant details on policy
                status. | R12M | Data updated as of `
                  : `This view lists Plans owned by the selected Payer. It gives you the ability to see all relevant details on policy. Some columns are customizable and can be added/removed to fit needs. | R12M | Data updated as of `}
                {timeFrame?.dataRefreshDate}
              </p>
            </div>
          </Col>
        </Row>
        <PolicyDetailsFilters
          handleFilterChange={handleFilterChange}
          selectedPayer={selectedPayer}
          selectedPlan={selectedPlan}
          selectedProduct={selectedProduct}
          selectedIndication={selectedIndication}
          selectedCompetitorProduct={selectedCompetitorProduct}
          selectedEcosystemName={selectedEcosystemName}
          selectedBookOfBusiness={selectedBookOfBusiness}
          selectedBenefitType={selectedBenefitType}
          selectedPolicyState={selectedPolicyState}
        />
        &nbsp;
      </div>
      <Row id='PolicyDetail'>
        <Col xs={12}>
          <Spin spinning={isLoading || isExporting}>
            <ConfigurableTable
              rows={policiDetailsData?.values}
              columns={filteredColumns?.map((col) => {
                if (
                  col.key === 'ecosystem' &&
                  CUSTOMER_TYPE_FLAG.get(
                    CUSTOMER_TYPE_ENTITY.PARENTPAYER
                  )?.includes(selectedCustomer.flag)
                ) {
                  return {
                    ...col,
                    children: col.children.map((coll) => {
                      return coll;
                    }),
                  };
                } else if (col.key === 'policy') {
                  return {
                    ...col,
                    children: col.children.map((coll) => {
                      if (
                        coll.dataIndex === 'policyLink' &&
                        CUSTOMER_TYPE_FLAG.get(
                          CUSTOMER_TYPE_ENTITY.PAYER
                        ).includes(selectedCustomer?.flag)
                      ) {
                        return {
                          ...coll,
                          render: (text, record) => (
                            <>
                              {record?.policyLink ? (
                                <a
                                  target='_blank'
                                  rel='noreferrer'
                                  className='span-link'
                                  href={record?.policyLink}>
                                  Policy Link
                                </a>
                              ) : (
                                '-'
                              )}
                            </>
                          ),
                        };
                      } else if (coll.dataIndex === 'policyStatus') {
                        const info = CUSTOMER_TYPE_FLAG.get(
                          CUSTOMER_TYPE_ENTITY.PAYER
                        )?.includes(selectedCustomer.flag)
                          ? PAYER_VIEW_POLICY_STATUS_COLUMN_INFO
                          : PARENT_PAYER_VIEW_POLICY_STATUS_COLUMN_INFO;

                        return {
                          ...coll,
                          label: 'Policy Status',
                          title: renderPopOver(
                            'Policy Status',
                            info,
                            POLICY_STATUS_COL_POPOVER_LINK
                          ),
                        };
                      } else if (coll.dataIndex === 'accessPosition') {
                        const info = CUSTOMER_TYPE_FLAG.get(
                          CUSTOMER_TYPE_ENTITY.PAYER
                        )?.includes(selectedCustomer.flag)
                          ? PAYER_VIEW_RELATIVE_ACCESS_POSITION_COLUMN_INFO
                          : PARENT_PAYER_VIEW_RELATIVE_ACCESS_POSITION_COLUMN_INFO;

                        return {
                          ...coll,
                          label: RELATIVE_ACCESS_POSITION_COLUMN_NAME,
                          title: renderPopOver(
                            RELATIVE_ACCESS_POSITION_COLUMN_NAME,
                            info,
                            RELATIVE_ACCESS_POSITION_COLUMN_POPOVER_LINK
                          ),
                        };
                      } else if (
                        coll.dataIndex === 'policyUpdateURL' &&
                        CUSTOMER_TYPE_FLAG.get(
                          CUSTOMER_TYPE_ENTITY.PARENTPAYER
                        ).includes(selectedCustomer?.flag)
                      ) {
                        return {
                          ...coll,
                          render: (text, record) => (
                            <a
                              target='_blank'
                              rel='noreferrer'
                              className='span-link'
                              href={`${process.env.REACT_APP_POLICY_FEEDBACK_UPDATE_URL}&${record?.policyUpdateURLParams}`}>
                              Policy Intelligence Update Form
                            </a>
                          ),
                        };
                      }
                      return coll;
                    }),
                  };
                } else if (
                  col.dataIndex === 'mcoEntity' &&
                  col.key === 'EntityName'
                ) {
                  return {
                    ...col,
                    ...(selectedView === CUSTOMER_TYPE_ENTITY.PAYER && {
                      label: POLICY_DETAILS_PLAN_COLUMN_NAME,
                      title: POLICY_DETAILS_PLAN_COLUMN_NAME,
                      defaultSortOrder: 'ascend',
                    }),
                    ...(selectedView === CUSTOMER_TYPE_ENTITY.PARENTPAYER && {
                      render: (text, record) => (
                        <span
                          className='span-link'
                          onClick={() => handlePayerLinkClick(record)}>
                          {text?.entityName}
                        </span>
                      ),
                    }),
                  };
                } else if (col.key === 'MdmId') {
                  return {
                    ...col,
                    ...(selectedView === CUSTOMER_TYPE_ENTITY.PAYER && {
                      label: PAYER_MDM_ID_COLUMN_NAME,
                      title: PAYER_MDM_ID_COLUMN_NAME,
                    }),
                  };
                }
                return col;
              })}
              expandRowByClick={true}
              enableColumnSelection={false}
              enableExport={false}
              exportFileName='PolicyDetails'
              tableName={TABLE_NAME_POLICY_DETAILS}
              isGlobalExport={true}
              pagination={pagination}
              isGlobalSort={true}
              onSort={handleSorting}
              dimentions={size}
            />
          </Spin>
        </Col>
      </Row>
    </div>
  );
};

export default PolicyDetails;

const ColumnSelectionPanel = ({
  classes,
  selectedColumns,
  handleCheckboxChange,
  selectedView,
  columns,
}) => {
  return (
    <Checkbox.Group
      defaultValue={selectedColumns}
      className={classes.checkboxGroup}
      key={Math.random()}>
      {columns.map((column) => {
        let label = column.label ? column.label : column.title;
        if (selectedView === CUSTOMER_TYPE_ENTITY.PAYER) {
          if (column.key === 'EntityName') {
            label = POLICY_DETAILS_PLAN_COLUMN_NAME;
          }
          if (column.key === 'MdmId') {
            label = PAYER_MDM_ID_COLUMN_NAME;
          }
        }
        return (
          <div
            className={classes.checkboxWrapper}
            key={column.id}>
            <Checkbox
              className={`${classes.checkbox}`}
              key={column.key}
              value={column.key}
              disabled={column.columnVisiblity === ColumnVisiblity?.Mandatory}
              onChange={handleCheckboxChange}>
              <div className={`${classes['truncate-text']}`}>{label}</div>
            </Checkbox>
          </div>
        );
      })}
    </Checkbox.Group>
  );
};
